module.exports = __webpack_public_path__ + "img/excursion.15565f81.svg";